import styled from "styled-components";

export const PoWarehouseWrapper = styled.div`
.bar-item {
    display: flex;
    // justify-content: space-between;
    border: 1px solid ${({ theme }) => theme['secondary-color']};
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 24px;
    align-items: center;
    .search {
      width: 264px;
      margin-right:15px
    }
    .filter{
    width:150px;
    margin-right:15px
    }

    .select-status{
    width: 219px;
    }
}
.map-btn-wrapper{
    padding: 1px 6px;
    font-weight: 600;
    line-height: 22px;
    font-size: 10px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-color: #1565D8;
    color: #1565D8;
    &:not(:first-child){
      background-color: #1565D8;
      color: #fff;
    }
}
.disabled-save-button{
      background: #cccccc;
      color: #666666; 
      cursor: not-allowed; 
      pointer-events: none; 
      padding: 1px 6px;
      font-weight: 600;
      line-height: 22px;
      font-size: 10px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
`; 
export const ModalWrapper = styled.div`
.delete-modal-wrapper{
display:flex;
flex-direction:column;
align-items: center;
justify-content:space-between;
}`
